module.exports = __webpack_public_path__ + "static/media/34.7adfa09a.mp3";